<template>
<div v-loading="isLoading">
  <button
    @click="handleCommand()"
    class="btn btn-danger btn-fill btn-wd"
    title="Analisar todos os ids dos documentos em configurações e nos documentos do sistema, removendo duplicidades."
  >
    Remover duplicidade dos dados nas configurações
  </button>
  <el-progress :percentage="progressPercentage"/>
</div>
</template>

<script>
import CouchdbClass from 'src/services/CouchdbClass'
import swal from 'sweetalert2'

export default {
  name: 'RemoveConfigurationsDuplicated',
  data () {
    return {
      isLoading: false,
      progress: 0,
      total: 10000,
      usersByName: {},
      usersById: {},
      rolesById: {},
      rolesByName: {}
    }
  },
  computed: {
    couchdbUsers: function () {
      return new CouchdbClass({ connection: 'config', collection: 'users' })
    },
    couchdbases: function () {
      return {
        customers: new CouchdbClass({ connection: 'default', collection: 'customers' }),
        api: new CouchdbClass({ connection: 'config', collection: 'apis' }),
        categories: new CouchdbClass({ connection: 'config', collection: 'categories' }),
        manufacturers: new CouchdbClass({ connection: 'config', collection: 'manufacturers' }),
        project: new CouchdbClass({ connection: 'config', collection: 'project' }),
        roles: new CouchdbClass({ connection: 'config', collection: 'roles' }),
        tags: new CouchdbClass({ connection: 'config', collection: 'tags' }),
        docs: new CouchdbClass({ connection: 'docs', collection: 'docs' }),
        states: new CouchdbClass({ connection: 'states', collection: 'states' }),
        surveys: new CouchdbClass({ connection: 'surveys', collection: 'surveys' }),
        surveys_docs: new CouchdbClass({ connection: 'surveys_docs', collection: 'surveys' }),
        events: new CouchdbClass({ connection: 'default', collection: 'events' }),
        lamps: new CouchdbClass({ connection: 'default', collection: 'lamps' }),
        ranking: new CouchdbClass({ connection: 'default', collection: 'ranking' }),
        stocks: new CouchdbClass({ connection: 'default', collection: 'stocks' }),
        tickets: new CouchdbClass({ connection: 'default', collection: 'tickets' })
      }
    },
    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progress / this.total) * 100)
    }
  },
  methods: {
    async handleCommand () {
      this.isLoading = true
      this.total = Object.keys(this.couchdbases).length * 10 + 1
      this.progress = 0

      try {
        await this.getUsers()
        await this.getRoles()
      } catch (e) {
        console.log('could not get the users', e)
        this.finish()
      }
      try {
        swal({
          title: 'Atenção',
          text: `Todos os documentos estão sendo processados nesse momento. Continuar?.`,
          type: 'warning',
          confirmButtonText: 'Iniciar',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCloseButton: true,
          showConfirmButton: true,
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            await this.exec()
            return 'ok'
          }
        }).then(() => {
          setTimeout(function () {
            location.reload()
          }, 5000)
          swal({
            title: 'Quase finalizando',
            text: 'O processo está quase finalizando, aguarde o fim.',
            type: 'info',
            showConfirmButton: false
          })
        })
      } catch (e) {
        console.log(e)
      }
    },
    async exec () {
      let a = await new Promise(async (resolve) => {
        await this.changeRoleUsers()

        for (let collection in this.couchdbases) {
          console.log(collection)
          await this.changingProcess(this.couchdbases[collection])
          if (collection === 'customer') {
            break
          }
        }
        await this.removeUsersAndRoles()
        console.log('end')
        resolve(true)
      })
      return a
    },
    async changingProcess (couchdb) {
      let a = await new Promise(async (resolve) => {
        const results = await couchdb.limit(999999).get()
        if (results.length === 0) {
          resolve(false)
        }

        const datas = []
        for (let result of results) {
          if (!result.hasOwnProperty('userId')) {
            continue
          }

          if (!this.usersById.hasOwnProperty(result.userId)) {
            continue
          }

          const name = this.usersById[result.userId].name
          result.userId = this.usersByName[name][0]._id
          datas.push(result)
        }
        await couchdb._postBulkDocs(datas)
        resolve(true)
      })
      return a
    },
    changeRoleUsers () {
      return new Promise(async (resolve) => {
        const datas = []
        for (let user of Object.values(this.usersById)) {
          if (user.role === 'superadmin') {
            continue
          }

          if (!user.hasOwnProperty('role')) {
            continue
          }

          if (!this.rolesById.hasOwnProperty(user.role)) {
            continue
          }

          const name = this.usersById[user.userId].name
          user.userId = this.usersByName[name][0]._id
          datas.push(user)
        }

        this.couchdbUsers._postBulkDocs(datas)
        resolve(true)
      })
    },
    async removeUsersAndRoles () {
      let a = await new Promise(async (resolve) => {
        console.log('users removing')
        await this.remove(this.usersByName, this.couchdbUsers)
        console.log('roles removing')
        await this.remove(this.rolesByName, this.couchdbases.roles)
        resolve(true)
      })
      return a
    },
    async remove (obj, couch) {
      let a = await new Promise(async (resolve) => {
        for (let name in obj) {
          if (obj[name].length <= 1) {
            continue
          }
          for (let i = 1; i < obj[name].length; i++) {
            await couch._delete(obj[name][i]._id)
          }
        }
        resolve(true)
      })
      return a
    },
    getUsers () {
      return this.couchdbUsers.limit(9999)
        .get()
        .then(result => {
          this.usersByName = result.reduce((accumulated, current) => {
            if (!accumulated.hasOwnProperty(current.name)) {
              accumulated[current.name] = []
            }
            accumulated[current.name].push(current)
            return accumulated
          }, {})

          this.usersById = result.reduce((accumulated, current) => {
            accumulated[current._id] = current
            return accumulated
          }, {})
        })
    },
    getRoles () {
      return this.couchdbases.roles.limit(9999)
        .get()
        .then(result => {
          this.rolesByName = result.reduce((accumulated, current) => {
            if (!accumulated.hasOwnProperty(current.name)) {
              accumulated[current.name] = []
            }
            accumulated[current.name].push(current)
            return accumulated
          }, {})

          this.rolesById = result.reduce((accumulated, current) => {
            accumulated[current._id] = current
            return accumulated
          }, {})
        })
    },
    notifyFinish () {
      this.total = 1
      this.progress = 1
      swal({
        title: 'Sucesso',
        text: `Todas as lâmpadas foram atualizadas com seus respectivos ID dos eventos`,
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },
    finish () {
      this.isLoading = false
      this.progress = this.total
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/commands/RemoveConfigurationsDuplicated.vue